import React from 'react';
import { route } from '../Util';
import CommunicationStyle from './CommunicationStyle';
import UserIcon from './UserIcon';
import { userShape } from '../propTypes';

function UserPill({ user }) {
  if (!user || !user.id) {
    return null;
  }

  let pronouns;
  if (user.pronouns) {
    pronouns = (
      <small className="text-muted ml-2" style={{ fontWeight: 'normal' }}>
        {user.pronouns}
      </small>
    );
  }

  return (
    <a /* eslint-disable-line jsx-a11y/anchor-is-valid */
      className={`user-pill small ${user.deleted_at ? 'is-leaver' : ''}`}
      href={user.deleted_at ? '#' : route.profile(user)}
    >
      <div className="pill-inner">
        <div style={{ clear: 'both', paddingLeft: '24px' }}>
          <UserIcon
            user={user}
            size="20px"
            style={{
              left: '5px', top: '5px', position: 'absolute',
            }}
          />

          <strong style={{ display: 'block' }}>
            {' '}
            {user.name}
            {pronouns}
          </strong>
        </div>

        {user.communication_style_sorted && (
          <CommunicationStyle size="h3" styles={user.communication_style_sorted} />
        )}
      </div>
    </a>
  );
}

UserPill.propTypes = {
  user: userShape,
};

UserPill.defaultProps = {
  user: null,
};

export default UserPill;
